import {ProductResource} from '@services/resource/product-resource';
import {ImageResource} from '@services/resource/image-resource';
import {Startup} from '@services/model/startup';
import {UploadDocument} from '@services/resource/upload-document';
import {Eq} from 'fp-ts/lib/Eq';
import moment, {Moment} from 'moment';
import {VideoResource} from '@services/resource/video-resource';

export enum ProductStatus {
  created = 'created',
  requested = 'requested',
  denied = 'denied',
  approved = 'approved',
  invited = 'invited',
  notInvited = 'notinvited',
}
export enum votingProductStatus {
  approved = 'approved',
  invited = 'invited',
  notInvited = 'notinvited',
}

export const eqProductStatus: Eq<ProductStatus> = {
  equals: (x: ProductStatus, y: ProductStatus) => x === y,
};

export class Product {
  constructor(
    public readonly id: string | undefined,
    public readonly startupId: string,
    public readonly listed: string,
    public readonly name: string,
    public readonly claim: string,
    public readonly description: string,
    public readonly uvp: string,
    public readonly productGroup: string,
    public readonly packingUnit: string,
    public readonly coverImage: ImageResource | undefined,
    public readonly productImages: ImageResource[],
    public readonly pitchDeck: UploadDocument | undefined,
    public readonly documents: UploadDocument[],
    public readonly pitchVideo: VideoResource | undefined,
    public readonly startup: Startup | undefined,
    public readonly modified: Moment | undefined,
  ) {}

  public static fromResource(r: ProductResource): Product {
    return {
      id: r.id,
      startupId: r.startupId,
      listed: r.listed,
      name: r.name,
      claim: r.claim,
      description: r.description,
      uvp: r.uvp ? r.uvp.toString() : '',
      productGroup: r.productGroup,
      packingUnit: r.packingUnit,
      coverImage: r.coverImage,
      productImages: r.images,
      pitchDeck: r.pitchDeck,
      documents: r.documents,
      pitchVideo: r.pitchVideo,
      startup: r.startup ? Startup.fromResource(r.startup) : undefined,
      modified: r.modified ? moment(r.modified) : undefined,
    };
  }
}
